import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const StyledImage = styled.img`
  width: 100%;
  margin: 20px;

  ${breakpoint('tablet')`
    ${({alignment}) => ['left', 'right'].includes(alignment) ? `
      float: ${alignment};
      width: 50%;
    ` : ''};
  `}
`;
